import React, { useContext } from 'react';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';
import faq_content from './faq_content.json';
import { WindowSizeContext } from '/src/App';

import './style.css';

const Faq = () => {

    // Get the deviceType from the WindowSizeContext
    const { deviceType } = useContext(WindowSizeContext);

    // Get the category_name from each object in the faq_content array
    const categories = faq_content.map(item => item.category_name);

    // Generate FAQ structured data
    const generateFaqStructuredData = () => {
        const qaPages = [];

        faq_content.forEach(category => {
            category.faqs.forEach(faq => {
                qaPages.push({
                    "@context": "https://schema.org",
                    "@type": "QAPage",
                    "mainEntity": {
                        "@type": "Question",
                        "name": faq.question,
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": faq.answer
                        }
                    }
                });
            });
        });

        return qaPages;
    };

    // Scroll to section by id
    const handleJumpTo = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <HelmetProvider
                pageType="faq"
                structuredData={generateFaqStructuredData()}
            />
            <div className="static-page-content-frame" id="top">
                <h1>Frequently Asked Questions</h1>
                <div className="faq-jump-to-wrapper">
                    <div className="faq-jump-to-heading">Jump to Section</div>
                    <nav className={`faq-jump-to ${deviceType}`} aria-label="Jump to category">
                        <ul>
                            {categories.map(category => (
                                <li key={category}>
                                    <button
                                        className={`faq-jump-to-btn ${deviceType}`}
                                        onClick={() => handleJumpTo(`faq-${category.toLowerCase().replace(/\s+/g, '-')}`)}
                                    >
                                        {category}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
                <div className={`faq-sections ${deviceType}`}>
                    {faq_content.map(({ category_name, faqs }, idx) => (
                        <section
                            key={category_name}
                            id={`faq-${category_name.toLowerCase().replace(/\s+/g, '-')}`}
                            className="faq-category-section"
                            tabIndex={-1}
                            aria-labelledby={`faq-heading-${idx}`}
                        >
                            <div className="faq-category-header">
                                <h2 className="faq-category-title" id={`faq-heading-${idx}`}>{category_name}</h2>
                                <a href="#top" className="faq-back-to-top-link">Back to top</a>
                            </div>
                            <ul className="faq-list">
                                {faqs.map((faq, i) => {
                                    let faqAnswer = faq.answer;
                                    if (faq.has_link) { 
                                        // Get the link text, and replace it in the answer with a link to the link
                                        const linkText = faq.link_text;
                                        const link = faq.link;
                                        faqAnswer = faqAnswer.replace(linkText, `<a href="${link}">${linkText}</a>`);
                                    }
                                    
                                    return (
                                        <li key={i} className="faq-item">
                                            <h3 className="faq-question">{faq.question}</h3>
                                            <p className="faq-answer" dangerouslySetInnerHTML={{ __html: faqAnswer }} />
                                        </li>
                                    )
                                })}
                            </ul>
                            {idx < faq_content.length - 1 && <hr className="faq-divider" aria-hidden="true" />}
                        </section>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Faq;